import { Formik } from 'formik'
import PropTypes from 'prop-types'
import { Component } from 'react'

import { Text } from '@/components/Form'
import { Error } from '@/components/Icons'

import './index.scss'

import Button from '@/components/Button'

export default class DeleteConfirmationWithInput extends Component<any, any> {
  static displayName = 'DeleteConfirmationWithInput'

  static propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    itemName: PropTypes.string.isRequired,
    subMessage: PropTypes.object.isRequired,
    warning: PropTypes.object.isRequired,
    label: PropTypes.object.isRequired,
    cancel: PropTypes.object.isRequired,
    deleteMessage: PropTypes.object.isRequired,
    deleteButton: PropTypes.object.isRequired,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  }

  state = { itemNameConfirmation: '' }

  confirmItem = () => {
    return this.state.itemNameConfirmation === this.props.itemName
  }

  onConfirmationChange = (e: any) => {
    this.setState({ itemNameConfirmation: e.target.value })
  }

  render() {
    const { onConfirm, onCancel, subMessage, warning, label, cancel, deleteMessage, deleteButton, placeholder } =
      this.props
    return (
      <div className="confirmation__overlay">
        <div className="confirmation__box">
          <p className="confirmation__message">{deleteMessage}</p>
          <div className="confirmation__warning_block_wrapper">
            <div className="confirmation__icon">
              <Error />
            </div>
            <div className="confirmation__warning_block">
              <p>{warning}</p>
            </div>
          </div>
          <p className="confirmation__sub_message">{subMessage}</p>
          {/* @ts-expect-error */}
          <Formik initialValues={{ itemName: '' }}>
            <Text name="itemName" label={label} onChange={this.onConfirmationChange} placeholder={placeholder} />
          </Formik>
          <div className="confirmation__actionblock">
            <Button color="secondary" onClick={onCancel}>
              <span>{cancel}</span>
            </Button>
            <Button color="warning" onClick={onConfirm} disabled={!this.confirmItem()}>
              <span>{deleteButton}</span>
            </Button>
          </div>
        </div>
      </div>
    )
  }
}
